import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import Button from '@ui/buttons/Button'
import Input from '@ui/forms/Input'
import { ModalBottom } from '@ui/components/Modal'
import { useLogout } from 'hooks/useLogout'
import { colors } from '@ui/colors'

interface Props {
  open: boolean
  orderIds: string[]
  close: () => void
}

export default function PaymentHelpModal({ open, orderIds, close }: Props) {
  const { t } = useTranslation(['ui', 'payment'])
  const text = 'payment:help.modal'

  const logout = useLogout()

  return (
    <ModalBottom
      hideBottomSpace
      spacedText
      open={open}
      close={close}
      title={t(`${text}.title`)}
      desc={t(`${text}.desc`)}
      body={
        <View className="flex flex-col gap-12 px-16 pb-16">
          <Input readonly value={orderIds.join(', ')} label={t('ui:orderId')} />
          <View className="flex flex-row items-center justify-start gap-8">
            <Button
              variant="filled"
              label={t('ui:logout')}
              onPress={logout}
              colors={[colors.red[600], colors.red[700]]}
              iconEnd="logout"
            />
            <Button variant="outlined" label={t('ui:close')} onPress={close} />
          </View>
        </View>
      }
    />
  )
}
